import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFieldActivity from '../_reducers/fieldActivity';

export const selectFieldActivityState =
  createFeatureSelector<fromFieldActivity.FieldActivityState>('fieldActivities');

export const selectAllFieldActivities = createSelector(
  selectFieldActivityState,
  fromFieldActivity.selectAll
);

export const selectFieldActivityEntities = createSelector(
  selectFieldActivityState,
  fromFieldActivity.selectEntities
);

export const selectFieldActivityById = (id: number) =>
  createSelector(selectFieldActivityEntities, (entities) => entities[id]);

export const selectFieldActivityTotal = createSelector(
  selectFieldActivityState,
  fromFieldActivity.selectTotal
);

export const selectFieldActivityWithStatus = createSelector(
  selectFieldActivityState,
  selectAllFieldActivities,
  (state, fields) => ({
    fields,
    loading: state.loading,
    loaded: state.loaded,
    error: state.error,
  })
);
